/// <amd-module name="TFS/Admin/Views/Teams/Components/teamsHub" />
import * as React from "react";

import { DynamicModuleLoader } from "redux-dynamic-modules";
import { ConnectedTeamsPageContentView } from "TFS/Admin/Views/Teams/Components/TeamsPageContentView";
import { getTeamsModule } from "TFS/Admin/Views/Teams/redux/TeamsModule";
import { getTeamsHubRootProviderProps, ITeamsHubSagaContext } from "TFS/Admin/Views/Teams/redux/TeamsRootProviderProps";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IRootProviderProps, RootProvider } from "VSS/Redux/RootProvider";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";

export interface IProjectTeamsProps {}

export class TeamsHub extends VssComponent<IProjectTeamsProps> {
    private _hubViewState: VssHubViewState;
    private _context: IVssComponentContext;
    private rootProviderProps: IRootProviderProps<ITeamsHubSagaContext, any>;

    constructor(props: IProjectTeamsProps, context: IVssComponentContext) {
        super(props, context);

        this._context = context;
        this.rootProviderProps = getTeamsHubRootProviderProps(this.context.pageContext);
    }

    public render(): JSX.Element {
        this._initializeHubState(this._context);

        return (
            <RootProvider {...this.rootProviderProps}>
                <DynamicModuleLoader modules={[getTeamsModule()]}>
                    <ConnectedTeamsPageContentView hubViewState={this._hubViewState} context={this._context} />
                </DynamicModuleLoader>
            </RootProvider>
        );
    }

    // Hub initializer functions
    private _initializeHubState(context: IVssComponentContext): void {
        this._hubViewState = new VssHubViewState(context.pageContext);
    }
}

VssComponent.register("ms.vss-admin-web.project-teams-component", TeamsHub);
